// castle html content category
export const CASTLE_CONTENT_CATEGORY = {
  selfie: "castle-selfie",
  dessert: "castle-dessert",
  serviceQna: "castle-service-qna",
  preservationQna: "castle-preservation-qna",
  commonDesc: "common-desc",
  commonPremiumDesc: "common-premium-desc",
  conceptBooth: "castle-conceptbooth",
  premiumConceptBooth: "castle-premium-conceptbooth",
}

export const CONCEPT_BOOT_QNA = "castle-concept-qna"

export const AllTag = {
  id: "all",
  title: "전체",
}

export const Tags = [
  {
    id: "lovely",
    title: "러블리",
  },
  {
    id: "dreamy",
    title: "몽환",
  },
  {
    id: "cutie",
    title: "큐티",
  },
  {
    id: "fantastic",
    title: "판타지",
  },
  {
    id: "kitsch",
    title: "키치",
  },
  {
    id: "wedding",
    title: "웨딩",
  },
]

// 프리미엄샷 카테고리. 컨셉마다 concept_desc.category(배열)에 저장하고, 비어 있으면 공주에 넣는다.
// link가 있는 카테고리는 컨셉 목록 대신 그 화면으로 보낸다. icon은 탭 동그라미 사진.
export const PremiumCategories = [
  { id: "princess", icon: "/upload/concept/thumbnail_image/%EC%83%88%EB%B2%BD%EC%88%B2A-1787754479838.jpg" },
  { id: "birthday", icon: "/upload/concept/thumbnail_image/%EB%8D%94%EC%98%A4%ED%8C%94A-1790874525122.png" },
  { id: "couple", icon: "/concept_list/%EC%9E%91%EA%B0%80_%EC%97%86%EC%9D%8C/%5BSTORY%5D_SUMMERRIDE/sample/couple/6a753eda-8f15-4f16-b63e-4f38376f5c8f.png" },
  { id: "korean", icon: "/upload/concept/thumbnail_image/%EC%A0%95%EC%9B%94%EC%9D%98%EB%82%98%EB%82%A0A-1790338776036.png" },
  { id: "dark", icon: "/upload/concept/thumbnail_image/filename-1765704003706.png" },
  { id: "avique", icon: "/AVIQUE/%EC%9B%B9%EC%9A%A9%ED%8C%8C%EC%9D%BC/H.webp", link: "/eventPage/ID_princess", image: "/AVIQUE/웹용파일/A.webp" },
]

export const Holidays = ["2026-05-10", "2026-05-11", "2026-05-12", "2026-05-13", "2026-06-01"]

export const OperationTimeList = [
  "10:00",
  "10:15",
  "10:30",
  "10:45",
  "11:00",
  "11:15",
  "11:30",
  "11:45",
  "12:00",
  "12:15",
  "12:30",
  "12:45",
  "13:00",
  "13:15",
  "13:30",
  "13:45",
  "14:00",
  "14:15",
  "14:30",
  "14:45",
  "15:00",
  "15:15",
  "15:30",
  "15:45",
  "16:00",
  "16:15",
  "16:30",
  "16:45",
  "17:00",
  "17:15",
  "17:30",
  "17:45",
  "18:00",
  "18:15",
  "18:30",
  "18:45",
  "19:00",
  "19:15",
  "19:30",
  "19:45",
  "20:00",
  "20:15",
  "20:30",
  "20:45",
  "21:00",
  "21:15",
  "21:30",
  "21:45",
  "22:00",
]
export const SHOOTING_TIME = 45

export const PayOrderTypes = {
  OnlieReservation: "온라인예약",
  OnlineConceptBuy: "온라인키오스크컨셉구매",
  OnliePhotoTouch: "온라인추가보정신청",
  OnlineAddShot: "온라인키오스크추가촬영",
  OnlinePrint: "온라인인쇄",
}

export const AppVersion = 2605110

export const isMenuPage = (path) => {
  var ret = false
  switch (path) {
    case "/":
    case "/story":
    case "/story/detail":
    case "/funding":
    case "/funding/index.html":
    case "/location":
    case "/reservation/buy":
    case "/reservation/package":
    case "/auth/join/snsJoinForm":
    //case "/castle":
    case "/makeup":
    case "/mypage/home":
      ret = true
      break
    default:
      if (path.startsWith("/eventPage")) {
        ret = true
      } else if (path.startsWith("/booking/")) {
        ret = true
      }
      break
  }
  return ret
}

export const DEFAULT_PACKAGE_CODE = "default-package"
